import styled from 'styled-components';
import { Box, TextInput } from 'grommet';
import { parseMetricToNum } from 'grommet/utils/mixins';
export var StyledDropInput = styled(TextInput).withConfig({
  displayName: 'StyledDropInput',
  componentId: 'mqzg2z-0'
})(['padding-right:', 'px;'], function (props) {
  var widgetsBox = props.numWidgets * (24 + 2 * parseMetricToNum(props.theme.global.edgeSize.small)); // eslint-disable-next-line no-mixed-operators

  return widgetsBox + parseMetricToNum(props.theme.global.spacing) / 2 - parseMetricToNum(props.theme.global.control.border.width);
});
export var StyledDropInputContainer = styled.div.withConfig({
  displayName: 'StyledDropInput__StyledDropInputContainer',
  componentId: 'mqzg2z-1'
})(['position:relative;width:100%;cursor:pointer;']);
export var StyledWidgetsContainer = styled(Box).withConfig({
  displayName: 'StyledDropInput__StyledWidgetsContainer',
  componentId: 'mqzg2z-2'
})(['position:absolute;right:0;top:', ';'], function (props) {
  return -parseMetricToNum(props.theme.button.padding.vertical) + 'px';
});